import { Modal } from "antd";
import { useTranslation } from "react-i18next";
import { NAME_SPACES } from "shared/locales/constants";
import Button from "../../../Button";
import Header from "../../../Header";

function PromptModal({ open, onAccept, onClose }) {
  const { t } = useTranslation(NAME_SPACES.PUBLIC.ACORIS);
  const TRANSLATION = t("HELP_PROMPT", { returnObjects: true });

  return (
    <Modal
      open={open}
      onCancel={onClose}
      width={600}
      footer={null}
      className="acoris-help-modal"
      centered
    >
      <div className="acoris-help-modal__body">
        <Header title={TRANSLATION?.TITLE} highlight={TRANSLATION?.HIGHLIGHT} />
        <div className="acoris__actions acoris__actions--modal">
          <Button
            type="primary-outlined"
            className="acoris__actions--close-btn"
            onClick={onClose}
          >
            {TRANSLATION?.BUTTON?.DECLINE}
          </Button>
          <div className="acoris__actions--primary">
            <Button
              block
              type="primary"
              className="acoris__actions--next"
              onClick={onAccept}
            >
              {TRANSLATION?.BUTTON?.ACCEPT}
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default PromptModal;
